import replacementStore from './store'

export default class ReplacementModule {
  name = 'replacement'

  constructor({ store }) {
    store.registerModule(this.name, replacementStore)
  }
}
